module.exports = __webpack_public_path__ + "img/d200811-1.3fd6a88f.jpg";